import { SaleItemInterface } from "../../types/types"
import { unitTypeToShort } from "./enumToText"

export const formatSaleItemName = (
  item: SaleItemInterface,
  maxAttributes: number = 2
): string => {
  if (!item.attributes) return item.name
  
  const attrs = item.attributes
    .filter(attr => attr.isRequired)
    .slice(0, maxAttributes)
    .map(attr => {
      if (attr.fieldType === 0 || attr.fieldType === 1 || attr.valueType === 1) {
        let val = String(attr.value)
        if (attr.unit !== undefined && attr.unit !== -1) {
          val += ` ${unitTypeToShort(attr.unit)}`
        }
        return `${attr.name}: ${val}`
      }
      return null
    })
    .filter(Boolean)

  return attrs.length > 0 
    ? `${item.name} (${attrs.join(', ')})`
    : item.name
}
